import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MfFormControlComponent } from '../mf-form-control.component';
import { Moment } from 'moment';
import *  as moment from 'moment';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-mfcustom-date-picker',
  templateUrl: './mfcustom-date-picker.component.html',
  styleUrls: ['./mfcustom-date-picker.component.css']
})
export class MFCustomDatePickerComponent implements OnInit {
  @Output() public dataChange = new EventEmitter();
  @Input() fieldDisabled: boolean;
  @Input() htmlFormControl: UntypedFormControl;
  @Input() controlName: string;
  @Input() public set data(val) {
    this._data = val;
    if (val) {
      var date = moment(val);
      this._day = date.date();
      var month = this.months.filter(o => o.num == date.month() + 1);
      if (month.length > 0)
        this._month = month[0].value;
      this._year = date.year();


      
       //this.checkMinMax(date)
    }
    else {
      this._day = null;
      this._month = null;
      this._year = null;

    }
  };
  public get data() {
    return this._data;
  }
  @Input() parent: MfFormControlComponent;
  private _data: any;
  private _day: any;
  private _month: any;
  private _year: any;
  public get day() { return this._day }
  public get month() { return this._month }
  public get year() { return this._year }
  public set day(value) {
    if (value == "")
      value = null;
    this._day = this.isValidDay(value);
    //this._day = value;
    this.validateDate();
  }
  public set month(value) {
    if (this.day == null || typeof this.day == 'undefined' || this.day == '')
      this._day = 1;

    this._month = value;
    if (
      this.month != null && typeof this.month != 'undefined' && this.month != '' &&
      this.year != null && typeof this.year != 'undefined' && this.year != '' && this.year > 1900
    ) {

      var month = moment(Date.UTC(this.year, this.getMonth(this.month)));

      this.filteredDays.splice(0);
      this.days = new Array();
      for (var x = 1; x <= month.daysInMonth(); x++) {
        this.days.push({ label: (x < 10 ? "0" : "") + (x), value: x });
      }
      debugger;
      this.day = this.isValidDay(this.day);
      this.filterDay(this.day);
    }

    this.validateDate();
  }
  public set year(value) { this._year = value; this.validateDate(); }

  days: any = new Array();
  months: any = new Array();
  years: any = new Array();
  filteredDays: any = new Array();
  filteredMonths: any = new Array();
  filteredYears: any = new Array();
  isValidDay(day) {
    if (day != null && typeof day != 'undefined' && day != '' &&
      this.month != null && typeof this.month != 'undefined' && this.month != '' &&
      this.year != null && typeof this.year != 'undefined' && this.year != '' && this.year > 1900
    ) {

      var month = moment(Date.UTC(this.year, this.getMonth(this.month)));
      if (month.daysInMonth() < day)
        return month.daysInMonth();
    }
    return day
  }


  validateDate() {
    if ((this.day != null && typeof this.day != 'undefined' && this.day != '') ||
      (this.month != null && typeof this.month != 'undefined' && this.month != '') ||
      (this.year != null && typeof this.year != 'undefined' && this.year != '')
    ) {

      this.setValidDate(false, "Incomplete date");
    }
    if (this.day != null && typeof this.day != 'undefined' && this.day != '' &&
      this.month != null && typeof this.month != 'undefined' && this.month != '' &&
      this.year != null && typeof this.year != 'undefined' && this.year != '' && this.year > 1900
    ) {
      try {
        var date = moment(Date.UTC(this.year, this.getMonth(this.month), this.day));
        
        //if (this.checkMinMax(date))
          this.setValidDate(true);
      } catch  {
        date = null;
        this.setValidDate(false, "Invalid date");
      }


      this._data = date;
      this.dataChange.emit(this._data);
    }
    
  }
  //public checkMinMax(date) {
  //  var valid = true;
  //  var minValue = this.parent.formField.fieldOptions.minValue;
  //  var maxValue = this.parent.formField.fieldOptions.maxValue;
  //  minValue = new Date();
  //  if (minValue) {
  //    if (!date.isAfter(moment(minValue))) {
  //      this.setValidDate(false, "Invalid date - must be larger than " + minValue);
  //      valid = false;
  //    }
  //  }
  //  if (maxValue) {
  //    if (date.isAfter(moment(maxValue))) {
  //      this.setValidDate(false, "Invalid date - must be smaller than " + maxValue);

  //      valid = false;
  //    }
  //  }
  //  debugger;
  //  return valid;
  //}
  public setValidDate(valid: boolean, msg?) {
    if (this.parent && this.parent.formField && this.parent.formField.fieldOptions) {
      if (!valid)
        this.parent.validationMessage = msg;
      else this.parent.validationMessage = null;
    }
  }
  public getMonth(name, num?): number {
    var month = this.months.filter(o => o.label.toLowerCase().indexOf(name.toLowerCase()) === 0 || o.num == num);
    if (month.length > 0)
      return month[0].num - 1;
    else return 0;
  }
  constructor() {
    for (var x = 1; x <= 31; x++) {
      this.days.push({ label: (x < 10 ? "0" : "") + (x), value: (x < 10 ? "0" : "") + (x) });
    }
    var curYear = new Date().getFullYear() + 10;
    while (curYear > 1900) {
      this.years.push({ label: curYear.toString(), value: curYear.toString() });
      curYear--;
    }
    this.months.push({ label: 'Jan', value: 'Jan', num: 1 });
    this.months.push({ label: 'Feb', value: 'Feb', num: 2 });
    this.months.push({ label: 'Mar', value: 'Mar', num: 3 });
    this.months.push({ label: 'Apr', value: 'Apr', num: 4 });
    this.months.push({ label: 'May', value: 'May', num: 5 });
    this.months.push({ label: 'Jun', value: 'Jun', num: 6 });
    this.months.push({ label: 'Jul', value: 'Jul', num: 7 });
    this.months.push({ label: 'Aug', value: 'Aug', num: 8 });
    this.months.push({ label: 'Sep', value: 'Sep', num: 9 });
    this.months.push({ label: 'Oct', value: 'Oct', num: 10 });
    this.months.push({ label: 'Nov', value: 'Nov', num: 11 });
    this.months.push({ label: 'Dec', value: 'Dec', num: 12 });
    this.filterYear(null);
    this.filterMonth(null);
    this.filterDay(null);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

  }


  public filterDay(e) {

    if (e != null && typeof e != 'undefined' && e != '')
      this.filteredDays = this.days.filter(o => o.label.indexOf(e) === 0);
    else this.filteredDays = this.days;
  }
  public filterMonth(e) {
    var self = this;
    if (e != null && typeof e != 'undefined' && e != '')
      this.filteredMonths = this.months.filter(o => o.label.toLowerCase().indexOf(e.toLowerCase()) === 0 || o.num == e);
    else this.filteredMonths = this.months;
  }
  public filterYear(e) {
    if (e != null && typeof e != 'undefined' && e != '')
      this.filteredYears = this.years.filter(o => o.label.indexOf(e) === 0);
    else this.filteredYears = this.years;
	}

	onKey(event: any, maxVal, maxchars, model) {
		if (event.target.value.length > maxchars) {
			if (event.target.value[0] == "0")
				event.target.value = event.target.value.substring(1, event.target.value.length)

		}
		if (event.target.value.length > maxchars) {
			if (event.target.value[event.target.value.length - 1] == "0")
				event.target.value = event.target.value.substring(0, event.target.value.length)
		}
		if (event.target.value > maxVal) {
			event.target.value = maxVal;
		}
		if (event.target.value != model) {
			this[model] = event.target.value;
		}
	}
}
